var _style, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 102 102",
    style: {
      enableBackground: "new 0 0 102 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000058548946573747277980000006703595396871814574_);}\n\t.st1{fill:none;stroke:#363636;stroke-width:2;stroke-miterlimit:10;}\n\t.st2{clip-path:url(#SVGID_00000004521018679675326960000004011247236504611473_);}\n\t.st3{fill:none;stroke:#323243;stroke-width:2;stroke-linejoin:round;}\n\t.st4{fill:none;stroke:#323243;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "3.5,26 98.5,26 98.5,75.9 3.5,76  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013163028052639332280000014574521209996277688_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000013163028052639332280000014574521209996277688_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1.297)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.1,73h91.7V26.3H4.1V73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.8,68.5H16.5l0,0c0-4.4-3.6-11-8-11V41.6c4.4,0,8-6.6,8-11h66.4c0,4.4,3.6,11,8,11v15.9 C86.4,57.6,82.8,64.1,82.8,68.5z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNote);
export default __webpack_public_path__ + "static/media/empty-note.90f6c84b4cdaec8c64d8c0e71c10eef0.svg";
export { ForwardRef as ReactComponent };